import { Pipe, PipeTransform } from '@angular/core';
import { PrettyJsonTransformArgs } from '../types';

const DEFAULT_PADDING = 4;
const DEFAULT_INDENTATION = 3;
const HTML_ENTITIES = [
  { char: '&', entity: '&amp;' },
  { char: '<', entity: '&lt;' },
  { char: '>', entity: '&gt;' },
];
const JSON_REGEX =
  // eslint-disable-next-line no-useless-escape
  /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g;

@Pipe({
  name: 'prettyJson',
  pure: true,
})
export class PrettyJsonPipe implements PipeTransform {
  transform(value: unknown, args: PrettyJsonTransformArgs[]): string {
    try {
      return this.applyColors(
        typeof value === 'object' ? value : JSON.parse(value as string),
        args[0].showNumberLine,
        args[0].padding,
      );
    } catch (e) {
      return this.applyColors(
        { error: e },
        args[0].showNumberLine,
        args[0].padding,
      );
    }
  }

  applyColors(
    obj: Record<string, unknown> | string,
    showNumberLine = false,
    padding = DEFAULT_PADDING,
  ): string {
    let line = 1;

    if (typeof obj !== 'string') {
      obj = JSON.stringify(obj, undefined, DEFAULT_INDENTATION);
    }

    let strObj = obj as string;

    HTML_ENTITIES.forEach(({ char, entity }) => {
      strObj = strObj.replace(new RegExp(char, 'g'), entity);
    });

    strObj = strObj.replace(JSON_REGEX, (match: string) => {
      let themeClass = 'number';
      if (/^"/.test(match)) {
        themeClass = /:$/.test(match) ? 'key' : 'string';
      } else if (/true|false/.test(match)) {
        themeClass = 'boolean';
      } else if (/null/.test(match)) {
        themeClass = 'null';
      }
      return `<span class="${themeClass}">${match}</span>`;
    });

    return showNumberLine
      ? strObj.replace(
          /^/gm,
          () =>
            `<span class="number-line pl-3 select-none">${String(line++).padEnd(padding)}</span>`,
        )
      : strObj;
  }
}
